import styled, { css } from 'styled-components';

export const AlertListHeaderStyle = css`
    display: flex;
    align-items: center;
    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    height: 53px;
    background-color: #ffffff;
    color: #555555;
    text-transform: uppercase;
    padding: 3%;
    border-bottom: 1px solid #EEEEEE;
    width: 100%;
`;

export const AlertsListHeader = styled.div`
    ${AlertListHeaderStyle}
`;

interface IAlertsPagesListHeader {
    isFirePage?: boolean;
    isHurricanePage?: boolean;
}
export const AlertsPagesListHeader = styled.h1<IAlertsPagesListHeader>`
    ${AlertListHeaderStyle}
    padding: 0 3% 3%;
    ${({ isFirePage, isHurricanePage }) => (isFirePage || isHurricanePage) && `
        margin-bottom: 0px;
        margin-top: 0px;
        padding: 3%;
    `}
`;
